'use strict';

angular.module('client.services').factory('teksService', ['$rootScope', '$log',
  function ($rootScope, $log) {

    var LEVELS = {
      DISTRICT: 'district',
      SCHOOL: 'school',
      CURRICULUM: 'curriculum'
    };

    function isDistrictReport(ctrl) {
      return ctrl.currentLevel === LEVELS.DISTRICT;
    }

    function isSchoolReport(ctrl) {
      return ctrl.currentLevel === LEVELS.SCHOOL;
    }

    function isCurriculumReport(ctrl) {
      return ctrl.currentLevel === LEVELS.CURRICULUM;
    }

    function isTIAReport(ctrl) {
      return ctrl.isTIAReport;
    }

    function abbreviateNumber(num) {
      num = Number(num);
      if (num < 1000) {
        return '' + num;
      }
      var power = ((num).toPrecision(2).split("e")[1] || [0, 0]).slice(1);
      var triplets = Math.floor(power / 3);
      var numericResult = (num / Math.pow(10, triplets * 3)).toFixed(1);
      if (numericResult.length > 4) {
        numericResult = (num / Math.pow(10, triplets * 3)).toFixed();
      }
      return numericResult + ['', 'K', 'M', 'B', 'T'][triplets];
    }

    function getExportTimeOnTask(timeInSeconds) {
      var value = Math.round((timeInSeconds || 0) / 60);
      return value ? abbreviateNumber(value) : '';
    }

    function getTimeOnTask(timeInSeconds) {
      var value = Math.round((timeInSeconds || 0) / 60);
      return value ? abbreviateNumber(value) : '-';
    }

    function getFieldName(masterIndex, baseField) {
      return 'ex_' + masterIndex + '_' + baseField;
    }

    function renderAvgResp(val) {
      return val ? val : '-';
    }

    function renderQuizScore(val) {
      return (!val && val !== 0) ? '-' : val + '%';
    }

    function renderBreakouts(rec) {
      if (rec.breakouts_in_standard) {
        return rec.breakout_touched_count + '/' + rec.breakouts_in_standard;
      } else {
        return '';
      }
    }

    function calculateBreakoutsDonePercentage(rec) {
      if (rec.breakouts_in_standard && rec.breakout_touched_count) {
        return parseInt(rec.breakout_touched_count, 10) / parseInt(rec.breakouts_in_standard, 10);
      }
    }

    function getCustomElementBackgroundColor(columnName, value) {
      if (!columnName) {
        return;
      }
      var numValue = parseFloat(value);
      var percentage = 0;
      if (columnName.indexOf('number_of_breakouts') > -1) {
        if (!numValue) {
          return '#ffffff';
        }
        return 'rgba(170,170,170,' + (numValue) + ')';
      }
      if (columnName.indexOf('responses') > -1) {
        if (!numValue) {
          return '#ffffff';
        }
        return 'rgba(253, 180, 147,' + (numValue / 18) + ')';

      }
      if (columnName.indexOf('quiz') > -1) {
        if (isNaN(numValue)) {
          return '#ffffff';
        } else if (numValue > 49.5 && numValue < 50.5) {
          return '#ffffff';
        } else if (numValue < 50) {
          return 'rgba(230, 129, 114, ' + (1 - numValue * 0.02) + ')';
        } else if (numValue > 50) {
          return 'rgba(160, 223, 253, ' + (numValue * 0.02 - 1) + ')';
        }
      }
      if (columnName.indexOf('time_on_standard') > -1) {
        if (!numValue) {
          return '#ffffff';
        } else {
          // max value here is 60 minutes
          percentage = (numValue / (100 / 60));
          if (percentage > 99) {
            percentage = 100;
          }
          return 'rgba(245, 211, 40, ' + percentage * 0.01 + ')';
        }
      }
      return '';
    }

    function studentInCurrentClass(ctrl, formattedRow) {
      if (!ctrl.students || !ctrl.students.length || !ctrl.filterClass || !ctrl.filterClass.id) {
        return true;
      }
      let currentClassId = ctrl.students.find((st) => { return st.id === ctrl.filterClass.id; });
      if (!currentClassId) {
        return true;
      }
      return currentClassId.students.includes(formattedRow.studentId);
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function includeInAverage(row, ctrl) {
      if (isCurriculumReport(ctrl)) {
        return studentInCurrentClass(ctrl, row)
      }
      else if (isDistrictReport(ctrl) || isSchoolReport(ctrl)) {
        false; // return student.school_id === ctrl.filterSchool.id;
      }

      return false;
    }

    function isCurrentClassAverage(score, ctrl) {
      if (isCurriculumReport(ctrl)) {
        return ctrl.filterClass && score.cid === ctrl.filterClass.id;
      }
      return true;
    }

    function formatExperienceSummaryDataRow(ctrl, allRecs, expectationCodes, expectationsLabels, tiaTestScores, tiaAvgScores) {
      var byKey = {};

      var keyColumn;
      if (isCurriculumReport(ctrl)) {
        keyColumn = 'student_user_id';
      }
      if (isDistrictReport(ctrl) || isSchoolReport(ctrl)) {
        keyColumn = 'class_id';
      }
      allRecs.forEach(function (rec) {
        var key = rec[keyColumn];
        if (!byKey[key]) {
          byKey[key] = [];
        }
        byKey[key].push(rec);
      });

      let averages = {
        preTestTotalScore: 0,
        preTestCount: 0,
        postTestTotalScore: 0,
        postTestCount: 0,
        averageTotalScore: 0,
        averageCount : 0,
        growthTotalScore : 0,
        growthCount: 0
      };

      let formattedData = Object.keys(byKey).map(function (keyId) {
        var recs = byKey[keyId];
        var firstRec = recs[0];

        var row = {};
        let currentClassId = firstRec.class_id;

        if (isCurriculumReport(ctrl)) {
          row.studentId = firstRec.student_user_id;
          row.studentName = firstRec.student_first_name + ' ' + firstRec.student_last_name;
        }
        if (isDistrictReport(ctrl)) {
          row.schoolName = firstRec.school_name;
        }
        if (isDistrictReport(ctrl) || isSchoolReport(ctrl)) {
          row.teacherName = firstRec.teacher_first_name + ' ' + firstRec.teacher_last_name;
          row.teacherId = firstRec.teacher_user_id;
          row.className = firstRec.class_name;
          row.classId = firstRec.class_id;
          row.archivedInfo = firstRec.archived_info || false;
        }

        if (tiaTestScores) {
          let pretestStudent = tiaTestScores.find(function (score) {
            return score.id == keyId && score.pretest_tia;
          });
          if (pretestStudent) {
            row.preTest = renderQuizScore(pretestStudent.score);
            if (includeInAverage(row, ctrl)) {
              averages.preTestTotalScore = averages.preTestTotalScore + Math.round(pretestStudent.score);
              averages.preTestCount = averages.preTestCount + 1;
            }
            if (pretestStudent.growthTarget) {
              row.growthTarget = renderQuizScore(pretestStudent.growthTarget);
              if (includeInAverage(row, ctrl)) {
                averages.growthTotalScore = averages.growthTotalScore + Math.round(pretestStudent.growthTarget);
                averages.growthCount = averages.growthCount + 1;
              }
            } else {
              row.growthTarget = pretestStudent.growthTarget;
            }
          }
          let posttestStudent = tiaTestScores.find(function (score) {
            return score.id == keyId && score.posttest_tia;
          });
          if (posttestStudent) {
            row.postTest = renderQuizScore(posttestStudent.score);
            if (includeInAverage(row, ctrl)) {
              averages.postTestTotalScore = averages.postTestTotalScore + Math.round(posttestStudent.score);
              averages.postTestCount = averages.postTestCount + 1;
            }
          }
        }

        if (tiaAvgScores) {
          let avgScoreStudent = tiaAvgScores.find(function (score) {
            return score.id == keyId && isCurrentClassAverage(score, ctrl);
          });
          if (avgScoreStudent) {
            row.avgScore = renderQuizScore(avgScoreStudent.score);
            if (avgScoreStudent.score && includeInAverage(row, ctrl)) {
              averages.averageTotalScore = averages.averageTotalScore + Math.round(avgScoreStudent.score);
              averages.averageCount = averages.averageCount + 1;
            }
          }
        }

        expectationCodes.forEach(function (code) {
          var codeRecs = recs.filter(function (r) {
            return r.short_expectation_code === code;
          });

          row.expectation = expectationsLabels[code];

          codeRecs.forEach(function (rec) {
            if (isNumeric(rec.pretest_average_score)) {
              row[getFieldName(code, 'pretest')] = renderQuizScore(rec.pretest_average_score);
              row[getFieldName(code, 'pretest') + '_bg'] = getCustomElementBackgroundColor('quiz', rec.pretest_average_score);
              if ((rec.pretest_average_score || rec.pretest_average_score === 0) && includeInAverage(row, ctrl)) {
                averages[getFieldName(code, 'pretest')] = averages[getFieldName(code, 'pretest')] ? averages[getFieldName(code, 'pretest')] + Math.round(rec.pretest_average_score) : Math.round(rec.pretest_average_score);
                averages[getFieldName(code, 'pretest_count')] = averages[getFieldName(code, 'pretest_count')] ? averages[getFieldName(code, 'pretest_count')] + 1 : 1;
              }
            }
            if (isNumeric(rec.posttest_average_score)) {
              row[getFieldName(code, 'posttest')] = renderQuizScore(rec.posttest_average_score);
              row[getFieldName(code, 'posttest') + '_bg'] = getCustomElementBackgroundColor('quiz', rec.posttest_average_score);
              if ((rec.posttest_average_score || rec.posttest_average_score === 0) && includeInAverage(row, ctrl)) {
                averages[getFieldName(code, 'posttest')] = averages[getFieldName(code, 'posttest')] ? averages[getFieldName(code, 'posttest')] + Math.round(rec.posttest_average_score) : Math.round(rec.posttest_average_score);
                averages[getFieldName(code, 'posttest_count')] = averages[getFieldName(code, 'posttest_count')] ? averages[getFieldName(code, 'posttest_count')] + 1 : 1;
              }
            }
            // Student Summary and TIA return their quiz averages under different field names.
            const quizItemScore = isTIAReport(ctrl) ? rec.average_score : rec.avg_quiz_item_score;
            if (isNumeric(quizItemScore)) {
              row[getFieldName(code, 'quiz')] = renderQuizScore(quizItemScore);
              row[getFieldName(code, 'quiz') + '_bg'] = getCustomElementBackgroundColor('quiz', quizItemScore);
              if ((quizItemScore || quizItemScore === 0) && includeInAverage(row, ctrl)) {
                averages[getFieldName(code, 'quiz')] = averages[getFieldName(code, 'quiz')] ? averages[getFieldName(code, 'quiz')] + Math.round(quizItemScore) : Math.round(quizItemScore);
                averages[getFieldName(code, 'quiz_count')] = averages[getFieldName(code, 'quiz_count')] ? averages[getFieldName(code, 'quiz_count')] + 1 : 1;
              }
            }

            let breakoutsDonePercentage = calculateBreakoutsDonePercentage(rec);
            row[getFieldName(code, 'number_of_breakouts')] = renderBreakouts(rec);
            row[getFieldName(code, 'number_of_breakouts') + '_bg'] = getCustomElementBackgroundColor('number_of_breakouts', breakoutsDonePercentage);
            if ((breakoutsDonePercentage || breakoutsDonePercentage === 0) && includeInAverage(row, ctrl)) {
              averages[getFieldName(code, 'number_of_breakouts')] = averages[getFieldName(code, 'number_of_breakouts')] ? averages[getFieldName(code, 'number_of_breakouts')] + breakoutsDonePercentage : breakoutsDonePercentage;
              averages[getFieldName(code, 'number_of_breakouts_count')] = averages[getFieldName(code, 'number_of_breakouts_count')] ? averages[getFieldName(code, 'number_of_breakouts_count')] + 1 : 1;
            }

            row[getFieldName(code, 'total_responses')] = renderAvgResp(rec.total_responses);
            row[getFieldName(code, 'total_responses') + '_bg'] = getCustomElementBackgroundColor('total_responses', rec.total_responses);
            if ((rec.total_responses || rec.total_responses === 0) && includeInAverage(row, ctrl)) {
              averages[getFieldName(code, 'total_responses')] = averages[getFieldName(code, 'total_responses')] ? averages[getFieldName(code, 'total_responses')] + Math.round(rec.total_responses) : Math.round(rec.total_responses);
              averages[getFieldName(code, 'total_responses_count')] = averages[getFieldName(code, 'total_responses_count')] ? averages[getFieldName(code, 'total_responses_count')] + 1 : 1;
            }

            row[getFieldName(code, 'responses')] = renderAvgResp(rec.responses);
            row[getFieldName(code, 'responses') + '_bg'] = getCustomElementBackgroundColor('responses', rec.responses);
            if ((rec.responses || rec.responses === 0) && includeInAverage(row, ctrl)) {
              averages[getFieldName(code, 'responses')] = averages[getFieldName(code, 'responses')] ? averages[getFieldName(code, 'responses')] + Math.round(rec.responses) : Math.round(rec.responses);
              averages[getFieldName(code, 'responses_count')] = averages[getFieldName(code, 'responses_count')] ? averages[getFieldName(code, 'responses_count')] + 1 : 1;
            }

            row[getFieldName(code, 'time_on_standard')] = getTimeOnTask(rec.time_on_standard);
            row[getFieldName(code, 'time_on_standard') + '_bg'] = getCustomElementBackgroundColor('time_on_standard', getTimeOnTask(rec.time_on_standard));
            if ((rec.time_on_standard || rec.time_on_standard === 0) && includeInAverage(row, ctrl)) {
              averages[getFieldName(code, 'time_on_standard')] = averages[getFieldName(code, 'time_on_standard')] ? averages[getFieldName(code, 'time_on_standard')] + Math.round(rec.time_on_standard) : Math.round(rec.time_on_standard);
              averages[getFieldName(code, 'time_on_standard_count')] = averages[getFieldName(code, 'time_on_standard_count')] ? averages[getFieldName(code, 'time_on_standard_count')] + 1 : 1;
            }
          });
        });
        return row;
      }).filter(function(formattedRow) {
        return (isCurriculumReport(ctrl) && studentInCurrentClass(ctrl, formattedRow)) || (!isCurriculumReport(ctrl) && (formattedRow.preTest || formattedRow.postTest));
      });
      if (isCurriculumReport(ctrl)) {
        let classAverageRow = calculateClassAverageRow(averages, expectationCodes);
        formattedData = [classAverageRow].concat(formattedData);
      }
      return formattedData;
    }

    function calculateClassAverageRow(averages, expectationCodes) {
      let classAverageRow = {
        studentName : 'Class Average',
        preTest: 0,
        growthTarget: 0,
        avgScore: 0,
        postTest: 0,
      }
      if (averages.preTestCount) {
        classAverageRow.preTest = renderQuizScore(Math.round(averages.preTestTotalScore / averages.preTestCount));
      }
      if (averages.growthCount) {
        classAverageRow.growthTarget = renderQuizScore(Math.round(averages.growthTotalScore / averages.growthCount));
      }
      if (averages.averageCount) {
        classAverageRow.avgScore = renderQuizScore(Math.round(averages.averageTotalScore / averages.averageCount));
      }
      if (averages.postTestCount) {
        classAverageRow.postTest = renderQuizScore(Math.round(averages.postTestTotalScore / averages.postTestCount));
      }

      expectationCodes.forEach(function (code) {
        if (averages[getFieldName(code, 'pretest_count')]) {
          classAverageRow[getFieldName(code, 'pretest')] = renderQuizScore(Math.round(averages[getFieldName(code, 'pretest')] / averages[getFieldName(code, 'pretest_count')]));
          classAverageRow[getFieldName(code, 'pretest') + '_bg'] = getCustomElementBackgroundColor('quiz', classAverageRow[getFieldName(code, 'pretest')]);
        }
        if (averages[getFieldName(code, 'posttest_count')]) {
          classAverageRow[getFieldName(code, 'posttest')] = renderQuizScore(Math.round(averages[getFieldName(code, 'posttest')] / averages[getFieldName(code, 'posttest_count')]));
          classAverageRow[getFieldName(code, 'posttest') + '_bg'] = getCustomElementBackgroundColor('quiz', classAverageRow[getFieldName(code, 'posttest')]);
        }
        if (averages[getFieldName(code, 'quiz_count')]) {
          classAverageRow[getFieldName(code, 'quiz')] = renderQuizScore(Math.round(averages[getFieldName(code, 'quiz')] / averages[getFieldName(code, 'quiz_count')]));
          classAverageRow[getFieldName(code, 'quiz') + '_bg'] = getCustomElementBackgroundColor('quiz', classAverageRow[getFieldName(code, 'quiz')]);
        }
        if (averages[getFieldName(code, 'total_responses_count')]) {
          classAverageRow[getFieldName(code, 'total_responses')] = renderAvgResp(Math.round(averages[getFieldName(code, 'total_responses')] / averages[getFieldName(code, 'total_responses_count')] * 10) / 10);
          classAverageRow[getFieldName(code, 'total_responses') + '_bg'] = getCustomElementBackgroundColor('total_responses', classAverageRow[getFieldName(code, 'total_responses')]);
        }
        if (averages[getFieldName(code, 'responses_count')]) {
          classAverageRow[getFieldName(code, 'responses')] = renderAvgResp(Math.round(averages[getFieldName(code, 'responses')] / averages[getFieldName(code, 'responses_count')] * 10) / 10);
          classAverageRow[getFieldName(code, 'responses') + '_bg'] = getCustomElementBackgroundColor('responses', classAverageRow[getFieldName(code, 'responses')]);
        }
        if (averages[getFieldName(code, 'time_on_standard_count')]) {
          classAverageRow[getFieldName(code, 'time_on_standard')] = getTimeOnTask(Math.round(averages[getFieldName(code, 'time_on_standard')] / averages[getFieldName(code, 'time_on_standard_count')]));
          classAverageRow[getFieldName(code, 'time_on_standard') + '_bg'] = getCustomElementBackgroundColor('time_on_standard', classAverageRow[getFieldName(code, 'time_on_standard')]);
        }

      });

      return classAverageRow;
    }

    function setColumns(ctrl, standardExpectations, filterColumn, expectationLabels) {
      var firstColumns = [];
      if (isCurriculumReport(ctrl)) {
        firstColumns.push(
          {
            field: 'studentName',
            title: 'Student',
            titleName: 'Student',
            filter: {studentName: 'text'},
            sortable: 'studentName',
            class: 'xp-report-medium-cell'
          }
        );
      }
      if (isDistrictReport(ctrl)) {
        firstColumns.push(
          {
            field: 'schoolName',
            title: 'School',
            titleName: 'School',
            filter: {schoolName: 'text'},
            sortable: 'schoolName',
            class: 'xp-report-medium-cell'
          }
        );
      }
      if (isDistrictReport(ctrl) || isSchoolReport(ctrl)) {
        firstColumns.push(
          {
            field: 'teacherName',
            title: 'Teacher',
            titleName: 'Teacher',
            filter: {teacherName: 'text'},
            sortable: 'teacherName',
            class: 'xp-report-medium-cell'
          }
        );
        firstColumns.push(
          {
            field: 'className',
            title: 'Class',
            titleName: 'Class',
            filter: {className: 'text'},
            sortable: 'className',
            class: 'xp-report-medium-cell'
          }
        );
      }
      if (isTIAReport(ctrl)) {
        firstColumns.push(
          {
            field: 'preTest',
            title: 'Pre Test',
            titleName: 'Pretest',
            sortable: false,
            class: 'text-center xp-report-tiny-cell'
          }
        );
        firstColumns.push(
          {
            field: 'growthTarget',
            title: 'Growth Target',
            titleName: 'GrowthTarget',
            sortable: false,
            class: 'text-center xp-report-tiny-cell'
          }
        );
        firstColumns.push(
          {
            field: 'avgScore',
            title: 'Avg Score',
            titleName: 'avgScore',
            sortable: false,
            class: 'text-center xp-report-tiny-cell'
          }
        );
        firstColumns.push(
          {
            field: 'postTest',
            title: 'Post Test',
            titleName: 'PostTest',
            sortable: false,
            class: 'text-center xp-report-tiny-cell'
          }
        );
      }
      var columns = [];
      standardExpectations.forEach(function (code) {
        if (filterColumn === 'number_of_breakouts') {
          columns.push({
            field: getFieldName(code, 'number_of_breakouts'),
            titleName: code,
            class: 'text-center xp-report-tiny-cell',
            title: code,
            headerTitle: expectationLabels[code],
            sortable: false
          });
        }
        if (filterColumn === 'responses') {
          columns.push({
            field: getFieldName(code, 'responses'),
            titleName: code,
            class: 'text-center xp-report-tiny-cell',
            title: code,
            headerTitle: expectationLabels[code],
            sortable: false
          });
        }
        if (filterColumn === 'total_responses') {
          columns.push({
            field: getFieldName(code, 'total_responses'),
            titleName: code,
            class: 'text-center xp-report-tiny-cell',
            title: code,
            headerTitle: expectationLabels[code],
            sortable: false
          });
        }
        if (filterColumn === 'quiz') {
          columns.push({
            field: getFieldName(code, 'quiz'),
            titleName: code,
            class: 'text-center xp-report-tiny-cell',
            title: code,
            headerTitle: expectationLabels[code],
            sortable: false
          });
        }
        if (filterColumn == 'pretest') {
          columns.push({
            field: getFieldName(code, 'pretest'),
            titleName: code,
            class: 'text-center xp-report-tiny-cell',
            title: code,
            headerTitle: expectationLabels[code],
            sortable: false,
            headerTemplateURL: (isDistrictReport(ctrl) || isSchoolReport(ctrl)) ? null : 'xp-report-experience-details-header-tia'
          });
        }
        if (filterColumn == 'posttest') {
          columns.push({
            field: getFieldName(code, 'posttest'),
            titleName: code,
            class: 'text-center xp-report-tiny-cell',
            title: code,
            headerTitle: expectationLabels[code],
            sortable: false,
            headerTemplateURL: (isDistrictReport(ctrl)  || isSchoolReport(ctrl)) ? null : 'xp-report-experience-details-header-tia'
          });
        }
        if (filterColumn === 'time_on_standard') {
          columns.push({
            field: getFieldName(code, 'time_on_standard'),
            titleName: code,
            class: 'text-center xp-report-tiny-cell',
            title: code,
            headerTitle: expectationLabels[code],
            sortable: false
          });
        }
      });

      ctrl.columns = firstColumns.concat(columns);
    }

    function renderReport(ctrl, standardExpectations, filterColumn, data) {
      setColumns(ctrl, standardExpectations, filterColumn, ctrl.standardExpectationLabels);
      ctrl.tableParams.settings({
        dataset: data
      });
    }

    function calculateExpectationCodes(data, typeId, conceptId) {
      if (typeId && conceptId) {
        return data[conceptId + ':' + typeId].codes;
      } else {
        return data.map(function (exp) {
          return exp.short_expectation_code;
        });
      }
    }

    function calculateExpectationLabels(data, typeId, conceptId) {
      if (typeId && conceptId) {
        return data[conceptId + ':' + typeId].expectations;
      } else {
        let labels = [];
        data.forEach(function (exp) {
          labels[exp.expectation_code] = exp.expectation_label;
        });
        return labels;
      }
    }

    function generateUniqueClassList(data, userId) {
      var idToName = {};
      data.forEach(function (rec) {
        idToName[rec.class_id] = rec.class_name;
      });
      var uniqueClasses = Object.keys(idToName).map(function (id) {
        var classRec = data.find(function (rec) {
          return rec.class_id === parseInt(id, 10);
        });
        return {
          id: classRec.class_id,
          name: classRec.class_name,
          status: classRec.class_status,
          teacherId: classRec.teacher_user_id
        };
      });
      if (userId) {
        uniqueClasses = uniqueClasses.filter(function (classRec) {
          return classRec.teacherId === userId;
        });
      }
      uniqueClasses = uniqueClasses.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      var active = uniqueClasses.filter(function (cl) {
        return cl.status.toUpperCase() === 'ACTIVE';
      });
      var inActive = uniqueClasses.filter(function (cl) {
        return cl.status.toUpperCase() !== 'ACTIVE';
      });
      if (inActive.length === 0) {
        return active;
      }
      return active.concat({id: 'none', name: '', status: 'DIVIDER'}).concat(inActive);
    }

    function generateUniqueSchoolList(data) {
      var idToName = {};
      data.forEach(function (rec) {
        idToName[rec.school_id] = rec.school_name;
      });
      var uniqueSchools = Object.keys(idToName).map(function (id) {
        var schoolRec = data.find(function (rec) {
          return rec.school_id === parseInt(id, 10);
        });
        return {
          id: schoolRec.school_id,
          name: schoolRec.school_name
        };
      })
        .sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      return uniqueSchools;
    }

    function generateUniqueTeacherList(data) {
      var idToName = {};
      data.forEach(function (rec) {
        if (rec.pretest || rec.posttest) {
          idToName[rec.teacher_user_id] = rec.teacher_first_name + " " + rec.teacher_last_name;
        }
      });
      var uniqueTeachers = Object.keys(idToName).map(function (id) {
        var teacherRec = data.find(function (rec) {
          return rec.teacher_user_id === parseInt(id, 10);
        });
        return {
          id: teacherRec.teacher_user_id,
          name: teacherRec.teacher_first_name + " " + teacherRec.teacher_last_name,
          schoolId: teacherRec.school_id
        };
      })
        .sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      return uniqueTeachers;
    }

    function generateUniqueTypeConceptFunction(filteredColumn) {
      return function getUniqueByColumn(data) {
        var columnId = filteredColumn + '_id';
        var columnName = filteredColumn + '_label';
        var idToName = {};
        Object.keys(data).forEach(function (key) {
          idToName[data[key][columnId]] = data[key][columnName];
        });
        return Object.keys(idToName)
          .sort(function (a, b) {
            return a.localeCompare(b, 'en', {numeric: true});
          })
          .map(function (id) {
            return {
              id: parseInt(id, 10) || 0,
              name: idToName[id]
            };
          });
      };
    }

    function getReportFilter(ctrl) {
      if (isCurriculumReport(ctrl)) {
        return function (rec) {
          return (
            (!ctrl.filterType.id || rec.type_id === ctrl.filterType.id) &&
            (!ctrl.filterConcept.id || rec.concept_id === ctrl.filterConcept.id)
          );
        };
      } else if (isDistrictReport(ctrl)) {
        return function (rec) {
          return (
            (!ctrl.filterSchool || ctrl.filterSchool.id == 'none' || rec.school_id === ctrl.filterSchool.id) &&
            (!ctrl.filterTeacher || ctrl.filterTeacher.id == 'none' || rec.teacher_user_id === ctrl.filterTeacher.id) &&
            (!ctrl.filterType.id || rec.type_id === ctrl.filterType.id) &&
            (!ctrl.filterConcept.id || rec.concept_id === ctrl.filterConcept.id)
          );
        };
      } else if (isSchoolReport(ctrl)) {
        return function (rec) {
          return (
            (!ctrl.filterTeacher || ctrl.filterTeacher.id == 'none' || rec.teacher_user_id === ctrl.filterTeacher.id) &&
            (!ctrl.filterType.id || rec.type_id === ctrl.filterType.id) &&
            (!ctrl.filterConcept.id || rec.concept_id === ctrl.filterConcept.id)
          );
        };
      }
      return function (rec) {
        return (
          (!ctrl.filterType.id || rec.type_id === ctrl.filterType.id) &&
          (!ctrl.filterConcept.id || rec.concept_id === ctrl.filterConcept.id)
        );
      };
    }

    function getStyleClass(staticColumns, columnName) {
      if (!staticColumns || !columnName) {
        return;
      }
      if (staticColumns.indexOf(columnName) > -1) {
        return 'xp-report-medium-cell';
      } else {
        return 'xp-report-small-box';
      }
    };

    function getTitlePopup(staticColumns, columnName, data, columnTitle) {
      if (!staticColumns || !columnName) {
        return;
      }
      if (staticColumns.indexOf(columnName) > -1) {
        return columnTitle + ': ' + data;
      } else {
        return columnTitle;
      }
    };

    function setSchool(ctrl, selection) {
      if (!selection || !selection.id) {
        ctrl.filterSchool = false;
        return false;
      }
      ctrl.filterSchool = selection;
      return updateReport(ctrl);
    };

    function setTeacher(ctrl, selection) {
      if (!selection || !selection.id) {
        ctrl.filterTeacher = false;
        return false;
      }
      ctrl.filterTeacher = selection;
      return updateReport(ctrl);
    };

    function setClass(ctrl, selection) {
      if (!selection || !selection.id) {
        ctrl.filterClass = false;
        return false;
      }
      if (selection.id === 'none') {
        return false;
      }
      ctrl.filterClass = selection;
      return updateReport(ctrl);
    };

    function setMetric(ctrl, selection) {
      ctrl.filterMetricName = selection.name;
      ctrl.filterMetric = selection.id;
      setColumns(ctrl, ctrl.standardExpectations, selection.id, ctrl.standardExpectationLabels);
    };

    function updateReport(ctrl) {
      var reportData = (ctrl.reportData || []).filter(getReportFilter(ctrl));
      ctrl.standardExpectations = calculateExpectationCodes(ctrl.expectationCodes, ctrl.filterType.id, ctrl.filterConcept.id);
      ctrl.standardExpectationLabels = calculateExpectationLabels(ctrl.expectationCodes, ctrl.filterType.id, ctrl.filterConcept.id);
      ctrl.data = formatExperienceSummaryDataRow(ctrl, reportData, ctrl.standardExpectations, ctrl.standardExpectationLabels, ctrl.tiaTestScores, ctrl.tiaAvgScores);
      renderReport(ctrl, ctrl.standardExpectations, ctrl.filterMetric, ctrl.data);
    }

    function exportColumns(ctrl) {
      var csvColumns = [];
      if (isDistrictReport(ctrl)) {
        csvColumns.push(
          {
            name: 'Campus',
            field: 'schoolName',
            wrap: true
          }
        );
      }
      if (isDistrictReport(ctrl) || isSchoolReport(ctrl)) {
        csvColumns.push(
          {
            name: 'Teacher Name',
            field: 'prettyName',
            wrap: true
          }
        );
        csvColumns.push(
          {
            name: 'Teacher Email',
            field: 'teacherEmail',
            wrap: true
          }
        );
      }
      csvColumns.push(
        {
          name: 'Class Name',
          field: 'className',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Student Name',
          field: 'studentName',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Student Email',
          field: 'studentEmail',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'LMS ID',
          field: 'lmsId',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Pre Test Score',
          field: 'preTest',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Pre Test Date',
          field: 'preTestDate',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Growth Target',
          field: 'growthTarget',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Average Score',
          field: 'averageScore',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Post Test Score',
          field: 'postTest',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Post Test Date',
          field: 'postTestDate',
          wrap: true
        }
      );
      ctrl.standardExpectations.forEach(function (expectation) {
        csvColumns.push({
          name: expectation,
          field: expectation,
          wrap: true
        });
      });

      return csvColumns;
    }

    function newDataRow(row, tiaScores, tiaAverages) {
      var rec = {
        schoolName: row.school_name,
        prettyName: row.teacher_first_name + ' ' + row.teacher_last_name,
        teacherEmail: row.teacher_email,
        className: row.class_name,
        studentName: row.student_first_name + ' ' + row.student_last_name,
        studentEmail: row.student_email,
        lmsId: row.oneroster_id
      };
      let studentPretest = tiaScores.find(function (score) {
        return score.id === row.student_user_id && score.pretest_tia;
      });
      if (studentPretest) {
        rec.preTest = studentPretest.score;
        rec.growthTarget = studentPretest.growthTarget;
        rec.preTestDate = $rootScope.dateTimeFormatter(studentPretest.test_date);
      }
      let studentPosttest = tiaScores.find(function (score) {
        return score.id === row.student_user_id && score.posttest_tia;
      });
      if (studentPosttest) {
        rec.postTest = studentPosttest.score;
        rec.postTestDate = $rootScope.dateTimeFormatter(studentPosttest.test_date);
      }
      let studentAvgScore = tiaAverages.find(function (score) {
        return score.id === row.student_user_id;
      });
      if (studentAvgScore) {
        rec.averageScore = studentAvgScore.score;
      }
      return rec;
    }

    function sortExportData(a, b) {
      if (a.school_name) {
        let schoolCompare = a.school_name.localeCompare(b.school_name);
        if (schoolCompare != 0) {
          return schoolCompare;
        }
      }
      if (a.teacher_last_name) {
        let teacherLastNameCompare = a.teacher_last_name.localeCompare(b.teacher_last_name);
        if (teacherLastNameCompare != 0) {
          return teacherLastNameCompare;
        }
        let teacherFirstNameCompare = a.teacher_first_name.localeCompare(b.teacher_first_name);
        if (teacherFirstNameCompare != 0) {
          return teacherFirstNameCompare;
        }
      }
      let classCompare = a.class_name.localeCompare(b.class_name);
      if (classCompare != 0) {
        return classCompare;
      }
      let studentLastNameCompare = a.student_last_name.localeCompare(b.student_last_name);
      if (studentLastNameCompare != 0) {
        return studentLastNameCompare;
      }
      let studentFirstNameCompare = a.student_first_name.localeCompare(b.student_first_name);
      if (studentFirstNameCompare != 0) {
        return studentFirstNameCompare;
      }
      return 0;
    }

    function formatExportData(reportData, tiaScores, tiaAverages, metric) {
      let data = reportData.sort(sortExportData);
      let currentClassId = 0;
      let currentStudentId = 0;
      let rows = [];
      let currentRow = null;
      data.forEach(function (record) {
        if (currentClassId != record.class_id || currentStudentId != record.student_user_id) {
          if (currentRow) {
            rows.push(currentRow);
          }
          currentRow = newDataRow(record, tiaScores, tiaAverages);
          currentClassId = record.class_id;
          currentStudentId = record.student_user_id;
        }
        if (metric == 'pretest') {
          currentRow[record.short_expectation_code] = Math.round(record.pretest_average_score);
        } else if (metric == 'posttest') {
          currentRow[record.short_expectation_code] = Math.round(record.posttest_average_score);
        } else if (metric == 'quiz' && record.hasOwnProperty('avg_score')) {
          currentRow[record.short_expectation_code] = record.avg_score;
        } else if (metric == 'responses' && record.hasOwnProperty('responses')) {
          currentRow[record.short_expectation_code] = record.responses;
        } else if (metric == 'total_responses' && record.hasOwnProperty('total_responses')) {
          currentRow[record.short_expectation_code] = record.total_responses;
        } else if (metric == 'time_on_standard' && record.hasOwnProperty('time_on_standard')) {
          currentRow[record.short_expectation_code] = getExportTimeOnTask(record.time_on_standard);
        }
      });
      if (currentRow) {
        rows.push(currentRow);
      }
      return rows;
    }

    function exportData(ctrl, rawExportData, tiaTestScores, tiaTestAverages) {
      let data = rawExportData ? rawExportData : ctrl.reportData;
      let tiaScores = tiaTestScores ? tiaTestScores : ctrl.tiaTestScores;
      let tiaAverages = tiaTestAverages ? tiaTestAverages : ctrl.tiaAvgScores;
      let exportData = formatExportData(data, tiaScores, tiaAverages, ctrl.filterMetric);
      var csvRows = [];
      for (var i = 0; i < exportData.length; i++) {
        csvRows.push(exportData[i]);
      }
      return csvRows;
    }

    function exportFile(ctrl) {
      return (ctrl.parent.title || 'TIA') + ' ' + ctrl.filterMetricName + '.csv';
    }

    function parseStudentBlob(rec) {
      if (!rec.students) {
        return {};
      }
      var jsonBlob = "[" + rec.students + "]";
      try {
        var std = JSON.parse(jsonBlob);
        return {
          students: std,
          class_id: rec.class_id
        };
      }
      catch (e) {
        return {};
      }
    }

    function parseExpBlob(expRaw) {
      var jsonBlob = "[" + expRaw + "]";
      try {
        var listedBlankExp = {};
        var experiences = JSON.parse(jsonBlob)
          .filter(function (exp) {
            if (exp.was_taught) {
              return true;
            }
            if (listedBlankExp[exp.name]) {
              return false;
            }
            listedBlankExp[exp.name] = true;
            return true;
          });

        var taughtExperiences = experiences
          .filter(function (exp) {
            return exp.was_taught;
          }).sort(compareTaughtExperiences);

        var nonTaughtExperiences = experiences
          .filter(function (exp) {
            return !exp.was_taught;
          })
          .sort(function (a, b) {
            return a.name.localeCompare(b.name, 'en', {numeric: true});
          });

        return taughtExperiences.concat(nonTaughtExperiences);
      }
      catch (e) {
        return [];
      }
    }

    function compareTaughtExperiences(a, b) {
      return a.name.localeCompare(b.name, 'en', {numeric: true}) || ((new Date(a.ends_at || 0)).getTime() - (new Date(b.ends_at || 0)).getTime());
    }

    function getSummaryCells(rawSummaries) {
      var summaries = {};

      rawSummaries.forEach(function (sum) {
        sum.masters_list = sum.masters_list.replaceAll("’", "'");
        if (!summaries[sum.standard_id]) {
          summaries[sum.standard_id] = {
            standard_id: sum.standard_id,
            experiences_taught_count: 0,
            masters_touching_standard_count: 0,
            experiences: [],
            studentIds: [],
            taught: '0/0',
            students: 0,
            responses: 0,
            total_responses: 0,
            avg_quiz_item_score: 0,
            time_on_standard: 0,
            time: '-',
            quiz: '-'
          };
        }
        summaries[sum.standard_id].experiences_taught_count += (sum.experiences_taught_count || 0);
        summaries[sum.standard_id].time_on_standard += (sum.time_on_standard || 0);
        if (sum.responses) {
          summaries[sum.standard_id].responses = sum.responses;
        }
        if (sum.total_responses) {
          summaries[sum.standard_id].total_responses = sum.total_responses;
        }
        summaries[sum.standard_id].avg_quiz_item_score = sum.avg_quiz_item_score;
        (parseStudentBlob(sum).students || []).forEach(function (rec) {
          summaries[sum.standard_id].studentIds.push(rec.user_id);
        });
        summaries[sum.standard_id].experiences = summaries[sum.standard_id].experiences.concat(parseExpBlob(sum.masters_list));

        summaries[sum.standard_id].masters_touching_standard_count = (summaries[sum.standard_id].experiences || [])
          .map(function (xp) {
            return (xp || {}).master_id;
          })
          .filter(function onlyUnique(value, index, self) {
              return self.indexOf(value) === index;
            }
          ).length || 0;

        var taughtExperiences = summaries[sum.standard_id].experiences
          .filter(function (exp) {
            return exp.was_taught;
          }).sort(compareTaughtExperiences);

        var nonTaughtExperiences = summaries[sum.standard_id].experiences
          .filter(function (exp) {
            return !exp.was_taught;
          })
          .sort(function (a, b) {
            return a.name.localeCompare(b.name, 'en', {numeric: true});
          });

        summaries[sum.standard_id].experiences = taughtExperiences.concat(nonTaughtExperiences);

        summaries[sum.standard_id].studentIds = summaries[sum.standard_id].studentIds.filter(function (st, index, arr) {
          return arr.indexOf(st) === index;
        });

        summaries[sum.standard_id].taught = summaries[sum.standard_id].experiences_taught_count + '/' + summaries[sum.standard_id].masters_touching_standard_count;
        summaries[sum.standard_id].students = summaries[sum.standard_id].studentIds.length || '-';
        if (summaries[sum.standard_id].time_on_standard) {
          summaries[sum.standard_id].time = abbreviateNumber(summaries[sum.standard_id].time_on_standard);
        }
        if (summaries[sum.standard_id].avg_quiz_item_score !== null && summaries[sum.standard_id].avg_quiz_item_score !== '-') {
          summaries[sum.standard_id].quiz = summaries[sum.standard_id].avg_quiz_item_score + '%';
        }
      });
      return summaries;
    }

    return {
      LEVELS: LEVELS,
      isDistrictReport: isDistrictReport,
      isSchoolReport: isSchoolReport,
      isCurriculumReport: isCurriculumReport,
      generateUniqueClassList: generateUniqueClassList,
      generateUniqueSchoolList: generateUniqueSchoolList,
      generateUniqueTeacherList: generateUniqueTeacherList,
      generateUniqueTypeConceptFunction: generateUniqueTypeConceptFunction,
      updateReport: updateReport,
      getStyleClass: getStyleClass,
      getTitlePopup: getTitlePopup,
      setSchool: setSchool,
      setTeacher: setTeacher,
      setClass: setClass,
      setMetric: setMetric,
      setColumns: setColumns,
      exportColumns: exportColumns,
      exportData: exportData,
      exportFile: exportFile,
      getSummaryCells: getSummaryCells
    };
  }]);
